/** @jsx jsx */
import { FC } from 'react';
import { jsx } from '@emotion/core';
import { LoadingSpinnerProps } from './LoadingSpinner.types';
import { styles, svg, circle } from './LoadingSpinner.styles';

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 65, strokeWidth = 3, fill = '#707070', position = 'center' }) => {
  return (
    <div css={[styles({ position, fill, offset: 187 })]}>
      <svg css={svg({ offset: 187, fill })} width={`${size}px`} height={`${size}px`} viewBox={`0 0 66 66`} xmlns='http://www.w3.org/2000/svg'>
        <circle css={circle({ offset: 187, fill })} fill='none' strokeWidth={strokeWidth} strokeLinecap='round' cx='33' cy='33' r='30' />
      </svg>
    </div>
  );
};

export default LoadingSpinner;
